import React, { ReactElement } from "react";

interface Props {
  id: string;
  name: string;
  className?: string;
  value?: string;
  rows: number;
  required?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
  readOnly?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export default function TextAreaField(props: Props): ReactElement {
  const {
    className,
    id,
    name,
    value,
    rows,
    required,
    onChange,
    placeholder,
    style,
    readOnly = false,
  } = props;
  return (
    <textarea
      className={className}
      defaultValue={value}
      name={name}
      id={id}
      rows={rows}
      required={required}
      placeholder={placeholder}
      style={style}
      readOnly={readOnly}
      onChange={(e) => {
        if (onChange !== undefined) {
          onChange(e);
        }
      }}
    />
  );
}
